import { ApiResponse, AxiosErrorCustom, axiosInstance } from '@/lib/axios';
import { TypedMutationConfig } from '@/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import { z } from 'zod';
import { AxiosResponse } from 'axios';
import { TLabelAuto } from '../types/label-auto.type';

/**
 *
 */
export const deleteLabelAutoValidationSchema = z.object({
  labelId: z.string().min(1),
});
export type TDeleteLabelAutoValidation = z.infer<typeof deleteLabelAutoValidationSchema>;
export type TDeleteLabelAutoPayload = TDeleteLabelAutoValidation;
export type TDeleteLabelAutoResponse = AxiosResponse<ApiResponse<TLabelAuto>>;

export const deleteLabelAuto = (payload: TDeleteLabelAutoPayload): Promise<TDeleteLabelAutoResponse> => {
  const url = `/auto-label/${payload.labelId}`;

  return axiosInstance.delete(url);
};

/**
 * Use Delete Label Auto React-Query Hook
 */
type TUseDeleteLabelAutoMutationOptions = {
  mutationConfigOptions?: TypedMutationConfig<typeof deleteLabelAuto, AxiosErrorCustom>;
};

export const useDeleteLabelAutoMutation = ({ mutationConfigOptions }: TUseDeleteLabelAutoMutationOptions) => {
  const { ...restConfig } = mutationConfigOptions || {};

  return useMutation({
    ...restConfig,
    mutationFn: deleteLabelAuto,
  });
};
